<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<notifier-container></notifier-container>
<div class="container cvjEh">
  <div class="row">
    <div class="col-lg-12">
      <label class="directory" *ngIf="listingDetails.category && listingDetails.category.parentId">
        <i class="fas fa-tag"></i>
        {{ parentCategory }} > {{ listingDetails.category.name }}
      </label>
      <h4 class="text-break">{{ listingDetails.name }}</h4>

      <ng-container *ngIf="listingDetails.images && listingDetails.images; else fallbackImages">
        <ng-image-slider class="slider-css" [imagePopup]="true" [lazyLoading]="true" [infinite]="true" [imageSize]="{width: '500px', height: '350px', space: 10, 'object-fit': 'contain'}"
          [images]="listingImagesPosted" #nav>
        </ng-image-slider>
        <label class="directory"><i class="fas {{listingDetails.images.length == 1 ? 'fa-image' : 'fa-images'}}"></i> {{listingDetails.images.length}} {{listingDetails.images.length == 1 ? 'image' : 'images'}}</label>
      </ng-container>

      <ng-template #fallbackImages>
        <div class="col-lg-12 empty-photo empty-photo--details text-center">
          <img src="./assets/img/notfound.svg" style="object-fit: none;">
          <h5 class="rui-pt-sm">Oops! No photo found</h5>
          <p>
            We will see to it that this gets updated right away
          </p>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="row row-info">
    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 row-info__details">
      <div class="col-lg-12 no-padding">
        <div class="card-banner">
          <ng-container *ngIf="(listingUser$ | async) as listingUser">
            <div class="_Dh3n3 listing-user-photo"
              [ngStyle]="getBackgroundImageStyle(listingUser.photoURL | imageUrl | async)">
              <i class="fa fa-info-circle"></i>
            </div>
            <div class="_sFen3">
              <h5 style="margin: 0;">
                Owner Information
              </h5>
              <label class="_fbe25b">{{ listingUser.displayName }}</label>
              <!-- <label class="_fbe24b">{{ listingUser.address ? listingUser.address : 'No Location specified' }}</label> -->

              <!-- <div>
                <i class="fa fa-envelope-square" [ngClass]="{'text-success': listingUser.emailVerified}"
                  [ngbTooltip]="listingUser.emailVerified ? 'Email Verified' : 'Email Not Verified'"
                  aria-hidden="true"></i>&nbsp;
                <i class="fa fa-mobile" [ngClass]="{'text-success': listingUser.mobileVerified}"
                  [ngbTooltip]="listingUser.mobileVerified ? 'Mobile Verified' : 'Mobile Not Verified'"
                  aria-hidden="true"></i>
              </div> -->

              <br>
              <div _ngcontent-jvf-c321="" style="
                  display: inline-flex;
                  align-items: center;
                  color: #03c671;
              ">
                <svg *ngIf="listingUser.emailVerified || listingUser.mobileVerified" viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation" focusable="false"
                  style="display: block;height: 16px;width: 16px;fill: currentcolor;margin-right: 10px;">
                  <path
                    d="M16 .798l.555.37C20.398 3.73 24.208 5 28 5h1v12.5C29 25.574 23.21 31 16 31S3 25.574 3 17.5V5h1c3.792 0 7.602-1.27 11.445-3.832L16 .798zm7 9.08l-9.5 9.501-4.5-4.5L6.879 17l6.621 6.621L25.121 12 23 9.879z">
                  </path>
                </svg>
                <span *ngIf="listingUser.emailVerified || listingUser.mobileVerified">Verified via&nbsp;</span>
                <span *ngIf="listingUser.emailVerified">Email</span>
                <span *ngIf="listingUser.emailVerified && listingUser.mobileVerified">&nbsp;&&nbsp;</span>
                <span *ngIf="listingUser.mobileVerified">Mobile</span>
              </div>
            </div>
            <button class="white-button" [disabled]="isOwnListing()" mat-button (click)="sendMessage(listingDetails)">
              <span class="d-none d-sm-inline">Message </span>  
              <i class="fa fa-comment"></i>
            </button>
          </ng-container>
        </div>
        <br>
        <label class="_Djaqe1">
          <h5>Description</h5>
          <span [innerHtml]="listingDescription" class="text-break"></span>
        </label>
      </div>
      <div class="col-lg-12 specs-section no-padding hidden">
        <hr class="section-separator" />
        <label class="_Djaqe1">
          <h5>Specifications</h5>
          <div class="specs-list-wrap">
            <ul>
              <li *ngFor="let specification of listingDetails.specifications">
                {{ specification.name }}
              </li>
              <li *ngIf="!listingDetails.specifications">
                Oops! Guess we forgot to describe how awesome this is...
              </li>
            </ul>
          </div>
        </label>
      </div>
      <div class="col-lg-12 details-section no-padding">
        <hr class="section-separator" />
        <label class="_Djaqe1 location">
          <h5>Location</h5>
          {{ listingDetails.location }} <br>
          <app-listing-location-map class="location__map" *ngIf="listingDetails.address"
            [address]="listingDetails.address" [location]="listingDetails.location"></app-listing-location-map>
        </label>
      </div>
      <div class="col-lg-12 availability-section no-padding">
        <hr class="section-separator" />
        <label class="_Djaqe1">
          <h5>Availability</h5>
          <app-ri-calendar class="range-calendar" (onDateRangeSelected)="changeDateRangeCal1($event)"
            (onDateReset)="resetValues($event)" [dates]="dates" [reservedDates]="reservedDates" [reservationPage]="true"
            [calenderDisabled]="hasNoAvailability" [datePicker]="true" #cal1></app-ri-calendar>
          <div class="_djhuwW">
            <label>
              <i class="available"></i>
              <span>Available</span>
            </label>
            <label>
              <i class="rented"></i>
              <span>Reserved</span>
            </label>
          </div>
        </label>
      </div>
      <div class="col-lg-12 reviews-section no-padding">
        <div *ngIf="!listingDetails; else showReviews">
          <app-spinner></app-spinner>
        </div>
        <ng-template #showReviews>
          <app-listing-reviews [listing]="listingDetails"></app-listing-reviews>
        </ng-template>
      </div>
    </div>
    <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 row-info__price">
      <div class="price-detail-wrap">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="price-wrap">{{ listingDetails.rentalPrice | mcp }} <span>per day</span></h2>
            <div class="row calendar-wrap"></div>
            <div class="row calendar-wrap form-cal-wrap">
              <div class="col-lg-12 no-padding">
                <ng-container *ngIf="hasNoAvailability">
                  <h5>No Availability</h5>
                  <h6>{{ dates?.fromDate | date }} - {{ dates?.maxDate | date }}</h6>
                </ng-container>
                <ng-container *ngIf="!hasNoAvailability">
                  <app-ri-calendar class="range-calendar" (onDateRangeSelected)="changeDateRangeCal1($event)"
                    (onDateReset)="resetValues($event)" [dates]="dates" [reservedDates]="reservedDates"
                    [reservationPage]="true" #cal2></app-ri-calendar>
                </ng-container>
              </div>
            </div>
            <div class="row calendar-wrap">
              <button class="Gydhwj" mat-button [disabled]="hasNoAvailability || isOwnListing()"
                (click)="rentItem(listingDetails.id)">
                Rent It
              </button>
              <button class="rui-btn rui-btn--outline" [disabled]="isOwnListing()" (click)="sendMessage(listingDetails)"
                style="width:100%; margin-top: 0px; margin-bottom: 15px;">
                Send Owner a Message
              </button>
              <label class="_dhuwrnQ">You won't be charged yet.</label>
              <div class="col col-lg-12 pricing-details-section">
                <div class="row">
                  <div class="col-lg-2"
                    style="padding-left:0px;display: flex;justify-content: center;align-items: center;">
                    <img src="https://image.flaticon.com/icons/svg/393/393621.svg" style="width:40px;" />
                  </div>
                  <div class="col-lg-10 no-padding info">
                    <label>
                      This owner may require a cash deposit or your ID upon item collection. </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>